import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { addNecessaryAttributesToDyItems, filterOutDySizeVariants } from '../Utils/CustomCollectionUtils';

var useDyRecommendationWidget = function useDyRecommendationWidget(_ref) {
  var dySlug = _ref.dySlug,
      sizeOption = _ref.sizeOption,
      maxItems = _ref.maxItems;

  var _useState = useState({
    items: [],
    title: '',
    feedId: '',
    strategy: '',
    widgetId: ''
  }),
      _useState2 = _slicedToArray(_useState, 2),
      dyData = _useState2[0],
      setDyData = _useState2[1];

  var isMounted = useRef(false);

  useEffect(function () {
    isMounted.current = true;
    DYCS.recommendationWidgetData(dySlug).then(function (data) {
      var items = addNecessaryAttributesToDyItems(data.items).slice(0, maxItems);
      if (sizeOption != undefined) {
        items = filterOutDySizeVariants(items, sizeOption);
      }
      if (isMounted.current === true) setDyData({
        items: items,
        title: data.carouselTitle,
        feedId: data.feedId,
        strategy: data.strategy,
        widgetId: data.widgetId
      });
    }).catch(function (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    });
  }, [dySlug, sizeOption, maxItems]);

  return dyData;
};

useDyRecommendationWidget.propTypes = {
  dySlug: PropTypes.string.isRequired,
  sizeOption: PropTypes.string,
  maxItems: PropTypes.number.isRequired
};

export default useDyRecommendationWidget;